export default "__VITE_ASSET__BtxfMaDa__"